module.exports = __webpack_public_path__ + "static/img/ltc-chile.e5fdc08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/content-layout/assets/img/ltc-chile.svg
// module id = lIg+
// module chunks = 95